var _rect, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewCamera360Active(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 11.4286,
    fill: "#5485F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4287 16.0001C11.4287 15.3939 11.6695 14.8125 12.0982 14.3838C12.5268 13.9552 13.1082 13.7144 13.7144 13.7144H20.5716C21.1778 13.7144 21.7592 13.9552 22.1878 14.3838C22.6165 14.8125 22.8573 15.3939 22.8573 16.0001V25.1429C22.8573 25.7491 22.6165 26.3305 22.1878 26.7592C21.7592 27.1878 21.1778 27.4286 20.5716 27.4286H13.7144C13.1082 27.4286 12.5268 27.1878 12.0982 26.7592C11.6695 26.3305 11.4287 25.7491 11.4287 25.1429V16.0001ZM25.775 17.2641C25.5852 17.3589 25.4255 17.5047 25.3139 17.6852C25.2023 17.8656 25.1431 18.0736 25.143 18.2858V22.8572C25.1431 23.0694 25.2023 23.2774 25.3139 23.4578C25.4255 23.6383 25.5852 23.7841 25.775 23.8789L28.0607 25.0218C28.2349 25.1088 28.4285 25.1499 28.623 25.1412C28.8175 25.1324 29.0066 25.0741 29.1723 24.9717C29.3379 24.8694 29.4747 24.7264 29.5696 24.5563C29.6645 24.3863 29.7143 24.1948 29.7144 24.0001V17.1429C29.7143 16.9482 29.6645 16.7567 29.5696 16.5867C29.4747 16.4166 29.3379 16.2736 29.1723 16.1713C29.0066 16.0689 28.8175 16.0106 28.623 16.0018C28.4285 15.9931 28.2349 16.0342 28.0607 16.1212L25.775 17.2641Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewCamera360Active);
export default __webpack_public_path__ + "static/media/ViewCamera360Active.b50d96d3cae8fca3802f22d17e271218.svg";
export { ForwardRef as ReactComponent };